"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsIcon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme");
const StatsIcon = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "12", height: "13", viewBox: "0 0 12 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { onClick: onClick }),
        react_1.default.createElement("path", { d: "M2.167 12.9998H0V7.7998H2.167V12.9998Z", fill: Theme_1.theme.palette.BLUE_100 }),
        react_1.default.createElement("path", { d: "M8.2334 13.0002H6.06641V5.2002H8.2334V13.0002Z", fill: Theme_1.theme.palette.BLUE_100 }),
        react_1.default.createElement("path", { d: "M11.2666 13H9.09961V2.16699H11.2666V13Z", fill: Theme_1.theme.palette.BLUE_100 }),
        react_1.default.createElement("path", { d: "M5.20021 13H3.0332V0H5.20021V13Z", fill: Theme_1.theme.palette.BLUE_100 })));
};
exports.StatsIcon = StatsIcon;
exports.StatsIcon.defaultProps = {
    onClick: () => { }
};
